module.exports = __webpack_public_path__ + "img/alerts-7-mobile.49523e20.gif";